import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          WhatsApp Service
        </h2>
        <p className="text-gray-600">
          Carregando...
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;

